import twMerge from 'twMerge';

import Button from 'molecules/Button';
import Icon from 'molecules/Icon';

import { topBarContainer, topBarWrapper } from 'components/Header/styles/TopBar.styles';

import { contentfulProps } from 'utils/emptyTypes';

import type { HeaderProps } from '..';
import type { FC } from 'react';

const TopBar: FC<{ signInOptions: HeaderProps['signInOptions']; showPhoneNumber: HeaderProps['showPhoneNumber'] }> = ({
  signInOptions,
  showPhoneNumber,
}) =>
  signInOptions || showPhoneNumber ? (
    <div className={twMerge(topBarContainer())} data-cy="navSignIn">
      <div className={twMerge(topBarWrapper())}>
        {showPhoneNumber && (
          <a
            href="tel:+18667277473"
            className="flex items-center gap-2 text-md font-semibold text-white transition-opacity hover:opacity-70"
          >
            866-727-7473
          </a>
        )}
        {signInOptions && (
          <>
            {showPhoneNumber && <div className="block h-[16px] w-px bg-gray-200" />}
            <Button
              modal={{
                ...contentfulProps,
              }}
              className="flex items-center gap-2 text-md font-semibold text-white transition-opacity hover:opacity-70"
              signInOptions={signInOptions}
            >
              Sign In
              <Icon icon="login" size={24} className="fill-white" />
            </Button>
          </>
        )}
      </div>
    </div>
  ) : null;

export default TopBar;
